import * as React from "react";
import {
  Box,
  Stack,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import BackgroundImage from "../../images/background-image.webp";
import TokenStakingView from "./TokenStakeView";
import NFTStakingView from "./NFTStakeView";

const StakingView: React.FC = () => {
  return (
    <Stack alignItems={"center"} justifyContent={"center"} pt={"50px"}>
      <Box
        top={"0"}
        position={"fixed"}
        backgroundImage={BackgroundImage}
        backgroundSize="cover"
        width={"100%"}
        height={"100%"}
        opacity={0.5}
        zIndex={-3}
      />

      <Tabs variant={"enclosed"} align={"center"}>
        <TabList>
          <Tab>Stake Token</Tab>
          <Tab>Stake NFT</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <TokenStakingView />
          </TabPanel>
          <TabPanel>
            <NFTStakingView />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Stack>
  );
};

export default StakingView;
